import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrawer1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDrawer1"><Path fillRule="evenodd" clipRule="evenodd" d="M4 10.25V2H20V10.25H4ZM9 5H15V6.5H9V5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M4 11.75V20H6V22H7.5V20H16.5V22H18V20H20V11.75H4ZM9 15V16.5H15V15H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDrawer1;
